// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__UiPBi","spin":"LoadingSpinner_spin__UPoAk"};